import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    number: '01',
    emoji: '🎁',
    title: 'Primera Conversación',
    description: 'Exactamente qué decir en los primeros 3 minutos. Sin ensayar.',
    value: '$8.000'
  }, {
    number: '02',
    emoji: '🎁',
    title: 'El Momento de Avanzar',
    description: 'Cómo saber cuándo avanzar — y cómo hacerlo sin miedo al rechazo.',
    value: '$10.000'
  }, {
    number: '03',
    emoji: '🎁',
    title: 'Recuperación Rápida',
    description: 'Cuando algo no salió bien: el protocolo de 24hs para volver al juego.',
    value: '$9.000'
  }, {
    number: '04',
    emoji: '🎁',
    title: 'Lenguaje No Verbal',
    description: 'Los 7 cambios físicos que transforman cómo te perciben — sin hablar.',
    value: '$8.000'
  }, {
    number: '05',
    emoji: '🎁',
    title: 'Casos Comentados',
    description: '10 situaciones reales, analizadas paso a paso.',
    value: '$9.000'
  }];
  return <section className="py-24 md:py-32 px-4 bg-bg-card" data-id="element-18">
      <div className="max-w-[900px] mx-auto" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-4 text-center" data-id="element-20">
          🎁 5 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
        </motion.h2>
        <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-14" data-id="element-21" />

        <div className="space-y-4 mb-16" data-id="element-22">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-bg-section-alt border border-border-subtle rounded-xl p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6" data-id="element-23">
              <div className="text-text-gold text-4xl font-black flex-shrink-0 w-16" data-id="element-24">
                {bonus.number}
              </div>
              <div className="flex-1" data-id="element-25">
                <h3 className="text-text-primary font-bold text-xl mb-2" data-id="element-26">
                  {bonus.emoji} {bonus.title}
                </h3>
                <p className="text-text-secondary text-base" data-id="element-27">
                  {bonus.description}
                </p>
              </div>
              <div className="flex items-center gap-4 flex-shrink-0 bg-bg-card px-4 py-2 rounded-lg border border-border-subtle" data-id="element-28">
                <span className="text-red-strike line-through text-[13px]" data-id="element-29">
                  {bonus.value}
                </span>
                <span className="text-text-gold font-bold text-lg" data-id="element-30">
                  → GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-bg-section-alt border border-border-subtle rounded-xl p-8" data-id="element-31">
          <p className="text-red-strike text-xl line-through mb-2" data-id="element-32">
            Valor total bonos: $44.000
          </p>
          <p className="text-text-gold text-3xl md:text-4xl font-black" data-id="element-33">
            → GRATIS con tu EFECTO IMÁN
          </p>
        </motion.div>
      </div>
    </section>;
}